<template>
  <div class="live-quiz-cover" @click.stop="" v-if="showLiveQuiz">
    <div class="container" :class="{ fadeIn: isFade }" @click.stop>
      <div class="pack-icon" @click.stop="hideModal"><i></i></div>
      <div class="scroll-box">
        <div class="quiz-list" v-if="liveQuizList.length">
          <!-- 第一层基础数据 -->
          <div class="quizBox" v-for="(item, key) in liveQuizList" :key="key" :data-choosenum="item.chooseNum">
            <div class="header">
              <div class="finish">{{ item.endAt | time }}</div>
              <!-- <div class="left">{{ item.title }}</div>
              <div class="right">
                <div class="finish">{{ item.endAt | time }}</div>
              </div> -->
            </div>
            <div class="content disuse_pk">
              <div class="left-box">
                <div class="icon-bg">
                  <div class="icon">
                    <div
                      class="head"
                      :style="{
                        'background-image': `url(${item.questionDetail.objList[0].avatar})`,
                      }"
                    ></div>
                    <div class="frame"></div>
                  </div>
                  <div class="name">
                    <div class="label-box">
                      <span class="label-shadow">{{ item.questionDetail.objList[0].name }}</span>
                      <span class="label-text">{{ item.questionDetail.objList[0].name }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="middle-box">
                <div class="question">
                  <div class="title">
                    <div class="label-box">
                      <span class="label-shadow">{{ item.questionDetail.title }}</span>
                      <span class="label-text">{{ item.questionDetail.title }}</span>
                    </div>
                  </div>
                </div>
                <div class="compared">
                  <div class="inner">
                    <div class="yellow-side" :style="{ width: `${getItemPopularity(item, 0)}%` }"></div>
                    <div class="blue-side" :style="{ width: `${getItemPopularity(item, 1)}%` }"></div>
                  </div>
                  <div class="desc yellow-desc">
                    <div class="label-box" v-if="item.questionDetail.answers[0]">
                      <span class="label-shadow">{{ getItemPopularity(item, 0) }} % 支持</span>
                      <span class="label-text">{{ getItemPopularity(item, 0) }} % 支持</span>
                    </div>
                    <div class="label-box" v-else>
                      <span class="label-shadow">0 % 支持</span>
                      <span class="label-text">0 % 支持</span>
                    </div>
                  </div>
                  <div class="desc blue-desc">
                    <div class="label-box" v-if="item.questionDetail.answers[1]">
                      <span class="label-shadow">{{ getItemPopularity(item, 1) }} % 支持</span>
                      <span class="label-text">{{ getItemPopularity(item, 1) }} % 支持</span>
                    </div>
                    <div class="label-box" v-else>
                      <span class="label-shadow">0 % 支持</span>
                      <span class="label-text">0 % 支持</span>
                    </div>
                  </div>
                </div>
                <ul class="chooseList" v-if="item.questionDetail.answers.length">
                  <li v-for="(choose, index) in item.questionDetail.answers" :key="`choose-${choose.answerCode}`"
                    @click="handleQuiz(item, item.questionDetail, choose, index)">
                    <ui-frame-bg :colorType="colorMode[index]">
                      <div class="label-box">
                        <span class="label-shadow">{{ choose.answer }}</span>
                        <span class="label-text">{{ choose.answer }}</span>
                      </div>
                    </ui-frame-bg>
                    <!-- <span>{{ choose.answer }}</span> -->
                    <div class="rate">赔率：{{ choose.lossRate }}</div>
                  </li>
                  <div class="vs-icon"></div>
                </ul>
              </div>
              <div class="right-box" v-if="item.questionDetail.objList[1]">
                <div class="icon-bg">
                  <div class="icon">
                    <div
                      class="head"
                      :style="{
                        'background-image': `url(${item.questionDetail.objList[1].avatar})`,
                      }"
                    ></div>
                    <div class="frame"></div>
                  </div>
                  <div class="name">
                    <div class="label-box">
                      <span class="label-shadow">{{ item.questionDetail.objList[1].name }}</span>
                      <span class="label-text">{{ item.questionDetail.objList[1].name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Prompt :ref="`prompt${item.id}`"></Prompt>
          </div>
        </div>
        <div class="no-quiz" v-else>
          <Interdict layout="column" tip="竞猜暂未开启"></Interdict>
        </div>
      </div>
    </div>
    <!-- 投注弹窗 -->
    <Betting ref="betting"></Betting>
  </div>
</template>

<script>
import * as api from "@/service/index";
import Betting from "@/views/quiz/betting";
import Interdict from '@/components/interdict'
import Prompt from "@/components/prompt";
import UiFrameBg from '@/components/ui-frame-bg';

export default {
  components: {
    Betting,
    Prompt,
    Interdict,
    UiFrameBg
  },
  props: {
    liveQuizList: {
      type: [],
      default: () => [],
    },
    subScheduleTeams: {
      type: [],
      default: () => [],
    },
    token: {
      type: String,
    },
  },
  data() {
    return {
      showLiveQuiz: false,
      isFade: false,
      quizList: [],
      timer: null,
      colorMode: ['yellow', 'blue'],
    };
  },
  filters: {
    time: (val) => {
      let date = new Date(val);
      let hour = date.getHours();
      hour = hour < 10 ? "0" + hour : hour;
      let min = date.getMinutes();
      min = min < 10 ? "0" + min : min;

      return `${hour}:${min} 截止`;
    },
  },
  methods: {
    hideModal() {
      this.isFade = false;
      setTimeout(() => {
        this.showLiveQuiz = false;
      }, 500);
    },
    liveQuiz() {
      this.showLiveQuiz = true;
      setTimeout(() => {
        this.isFade = true;
      }, 100);
    },
    getDateTime(date) {
      return new Date(date).getTime();
    },


    async handleQuiz(quizInfo, selectInfo, answerInfo, index) {
      // console.log('index',index)
      // console.log('===========');
      // console.log('quizInfo',quizInfo);
      // console.log('selectInfo',selectInfo);
      // console.log('answerInfo',answerInfo);
      // console.log('===========');
      if (quizInfo.answer && quizInfo.answer != 0) {
        this.$refs[`prompt${quizInfo.id}`][0].setMsg("本场竞猜已结束");
      } else {
        // 获取服务器时间
        let currentTime = new Date();
        let result = await api.reqcurrentTime();
        if (result.status == 200) {
          currentTime = result.data;
        }

        if (this.getDateTime(currentTime) >= this.getDateTime(quizInfo.endAt)) {
          this.$refs[`prompt${quizInfo.id}`][0].setMsg("本场竞猜已结束");
        } else if (
          this.getDateTime(currentTime) < this.getDateTime(quizInfo.startAt)
        ) {
          this.$refs[`prompt${quizInfo.id}`][0].setMsg("本场竞猜未开始");
        } else {
          let obj = {};
          let other = {};
          let quizSubType = {
            1: "schedule",
            2: "live",
            3: "rankpk",
            4: "disusepk",
          }
          if (quizInfo.stype == 1) {
            // 战队预测
            obj = {
              question_id: quizInfo.id,
              lossRate: selectInfo.lossRate,
              obj_avatar: selectInfo.objList[0]?.avatar,
              obj_name: selectInfo.objList[0]?.name,
              answer_code: answerInfo.answerCode,
              answer_name: answerInfo.answer,
              ratios: selectInfo.answers[index].popularity
            };
          } else if (quizInfo.stype == 2) {

            obj = {
              question_id: quizInfo.id,
              lossRate: answerInfo.lossRate,
              obj_avatar: selectInfo.objList[index]?.avatar,
              obj_name: selectInfo.objList[index]?.name,
              answer_code: answerInfo.answerCode,
              answer_name: answerInfo.answer,
              ratios: selectInfo.answers[index].popularity
            };
            // 当前stype: 2的类型都走这个埋点参数
            other = {
              // 单项竞猜
              stype: 2,
              // 赛程id 
              schedule_id: quizInfo.scheduleCode,
              // 竞猜标题
              match_title: quizInfo['questionDetail']['title'],
              // 当前局数
              match_id: quizInfo.matchCode,
              // 竞猜类型
              type: quizInfo.type,
              subType: quizSubType[quizInfo.type],
              obj_name: selectInfo.objList[0]?.name,
            };
          }
          // console.log('object',obj);
          // console.log('object',other);
          // 实时竞猜的埋点
          this.$refs.betting.quiz(obj, other);
        }
      }
    },

    async liveGuess() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(async () => {
        try {
          // 优化  离开是，不在实时请求
          if (this.isFade) {
            this.$emit('custom-event');
          }
        } catch (err) {
          console.error(err);
        }
      }, 30000)
    },
    getItemPopularity(item, index) {
      const popularity = Number(item.questionDetail.answers[index]?.popularity * 100).toFixed(0) || 0;
      return popularity
    },
  },
  created() {
    // 在这个页面猜开启轮询
    this.liveGuess();

  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/live/live-quiz";

.content .question {
  justify-content: flex-start
}

.content .question .title {
  justify-content: center !important;
  text-align: center;
}

.content .question {}
</style>